import React, { useState } from "react";
import Sidebar from "../components/sidebar";
import { Toaster } from "react-hot-toast";
import { FiMenu } from "react-icons/fi";

function DefaultLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[radial-gradient(circle_at_top_left,rgba(14,165,233,0.12),transparent_32%),linear-gradient(180deg,#f8fbff_0%,#f3f7fb_100%)] text-slate-900 lg:grid lg:grid-cols-[300px_1fr]">
      <Toaster position="top-right" reverseOrder={false} />

      {/* Mobile / Tablet Backdrop */}
      {sidebarOpen && (
        <button
          type="button"
          aria-label="Close sidebar"
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 z-40 bg-black/50 backdrop-blur-sm lg:hidden"
        />
      )}

      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <main className="min-w-0 p-5 lg:p-8">
        {/* Mobile / Tablet Header */}
        <div className="mb-5 flex items-center lg:hidden">
          <button
            type="button"
            onClick={() => setSidebarOpen(true)}
            aria-label="Open sidebar"
            className="grid h-11 w-11 place-items-center rounded-xl bg-slate-950 text-white shadow-lg transition hover:bg-slate-800"
          >
            <FiMenu className="h-5 w-5" />
          </button>
        </div>

        {children}
      </main>
    </div>
  );
}

export default DefaultLayout;
